import {StyleSheet} from 'react-native';

const cardTokeniserTillStyles = StyleSheet.create({
  activity: {
    backgroundColor: 'black',
    position: 'absolute',
    width: '100%',
    height: '100%',
    zIndex: 400,
    opacity: 0.5,
  },
  button: {
    margin: 8,
    width: 120,
  },
  buttonContainer: {
    marginHorizontal: 8,
  },
  buttonRow: {
    flexDirection: 'row',
    justifyContent: 'center',
    marginBottom: 8,
    marginTop: 8,
  },
  form: {
    backgroundColor: 'white',
    paddingHorizontal: 4,
  },
  headerRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingRight: 8,
  },
  formRow: {
    flexDirection: 'row',
  },
  formRowField: {
    width: '100%',
    flex: 1,
  },
  keyAvoidScroll: {
    backgroundColor: 'white',
    borderRadius: 4,
    borderColor: 'grey',
    borderWidth: 0.5,
    paddingVertical: 4,
    paddingHorizontal: 6,
  },
  label: {
    color: 'rgb(134, 147, 158)',
    fontSize: 16,
    fontWeight: 'bold',
    paddingHorizontal: 10,
  },
  tillFieldsWrapper: {
    minHeight: 40,
    paddingHorizontal: 10,
  },
  tillFields: {
    minHeight: 36,
    height: 36,
    width: '100%',
  },
  validationError: {
    fontSize: 12,
    fontWeight: '400',
    color: 'red',
    marginTop: 2,
    marginBottom: 4,
    paddingHorizontal: 10,
    minHeight: 16,
  },
  webDesktopModalContent: {
    alignItems: 'center',
  },
  webview: {
    flex: 1,
    backgroundColor: 'transparent',
  },
});

export default cardTokeniserTillStyles;
